export default function getMinutes(position, isLeft) {
	if (isLeft) {
		if (position === 1) return ':00';
		if (position === 2) return ':15';
		if (position === 3) return ':30';
		return ':45';
	}

	if (position === 1) return ':15';
	if (position === 2) return ':30';
	if (position === 3) return ':45';
	return ':00';

}
